/**
 * Container for the Badge modal component
 */
import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'

import { Manifest } from 'mytours-read-api-typescript'
import { RootStoreState } from '../../root/index'
import { toggleBadgeModal } from '../actions'

export interface Props {
	showModal: boolean
	badgeId: number | undefined
	earned: boolean
	shouldBePushedToEarned: boolean
	appManifest?: Manifest
}

const mapStateToProps = (state: RootStoreState): Props => ({
	showModal: state.badges.showBadgeModal,
	badgeId: state.badges.selectedBadgeId,
	earned: state.badges.badgeEarned,
	shouldBePushedToEarned: state.badges.shouldBePushedToEarned,
	appManifest: state.settings.appManifest,
})

export interface Actions {
	toggleBadgeModal: (show: boolean, badgeId: number, shouldBePushedToEarned: boolean, earned: boolean) => void
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): Actions => ({
	toggleBadgeModal: (show: boolean, badgeId: number, shouldBePushedToEarned: boolean, earned: boolean) => {
		dispatch(toggleBadgeModal({ show, badgeId, earned, shouldBePushedToEarned }))
	},
})

export default (Component: React.ComponentType<Props & Actions>) =>
	connect(mapStateToProps, mapDispatchToProps)(Component)
